import React from "react";
import { connect } from "react-redux";
import getEvents from "../../api/events/getEvents";
import { showDetails, closeDetails } from "../../actions/events/events";
import Loader from "../../components/shared/ui/loader";
import EventsDisplay from "../../components/event/eventsDisplay";
import { translate } from "react-i18next";
import { compose } from "redux";

class DisplayContainer extends React.Component<any, any> {
  public componentWillMount() {
    this.fetchData();
  }

  public fetchData() {
    this.props.onGetEventsData();
  }

  public render() {
    const { t } = this.props;
    if (this.props.data && this.props.data.data && t) {
      if (this.props.data.data.length > 0) {
        return (
          <Loader status={this.props.data.status}>
            <EventsDisplay
              data={this.props.data.data}
              details={this.props.details}
              onShowDetails={this.props.onShowDetails}
              onCloseDetails={this.props.onCloseDetails}
            />
          </Loader>
        );
      } else if (t) {
        return <div>{t("noResults")}</div>;
      }
    }
    return <div />;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    data: state.events,
    details: state.eventDetails || {}
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetEventsData: () => {
      dispatch(getEvents());
    },
    onShowDetails: data => {
      dispatch(showDetails(data));
    },
    onCloseDetails: () => dispatch(closeDetails())
  };
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(DisplayContainer);
